import { render, staticRenderFns } from "./LiberarAsientoSkeleton.vue?vue&type=template&id=9a9caa60"
import script from "./LiberarAsientoSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./LiberarAsientoSkeleton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports